import * as React from 'react';
import { Text, PrimaryButton, ProgressIndicator, Separator, Stack, TextField, Toggle, DefaultButton, MessageBar } from '@fluentui/react';
import { IUserInvoiceInfo } from '../../../../Models/Admin/IUserInvoiceInfo';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { validateEmail } from '../../../../Tools/Validation';

interface IUserPropertiesInvoiceInformationProps {
    userInvoceInfo: IUserInvoiceInfo;
    isLoading: boolean;
    statusMessage?: IStatusMessage;
    changeInfoProperty: (key: string, value: any) => void;    
    valid: (state: boolean) => void;
}

export const UserPropertiesInvoiceInformation: React.FunctionComponent<IUserPropertiesInvoiceInformationProps> = (props) => {

    const [validation, setValidation] = React.useState<IUserInvoiceInfo>({
        billingCity: "",
        billingEmail: "",
        billingPostalCode: "",
        billingStreet: "",
        company: "",
        dic: "",
        ic: "",
        id: "",
        differentBillingAddress: false,
        isActive:false
    });

    const firmaChanged = (event?: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, checked ? true : false);
        }
    }

    const setInfoChange = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, newValue);
        }
    }

    const validate = (data: IUserInvoiceInfo): IUserInvoiceInfo=> {
        let result = { billingCity: "", billingEmail: "", billingPostalCode: "", billingStreet: "", company: "", dic: "", ic: "", id: "", differentBillingAddress: false, isActive: false };
        let valid = true;
        if (!validateEmail(data.billingEmail)) {
            result.billingEmail = "Zadejte prosím platnou emailovou adresu."
            valid = false;
        }
        
        if (data.billingStreet === "") {
            result.billingStreet = "Zadejte ulici."
            valid = false;
        }
        if (data.billingCity === "") {
            result.billingCity = "Zadejte město."
            valid = false;
        }
        if (data.billingPostalCode === "") {
            result.billingPostalCode = "Zadejte PSČ."
            valid = false;
        }
        props.valid(valid);
        return result;
    }

    React.useEffect(() => {
        setValidation(validate(props.userInvoceInfo));
    }, [props.userInvoceInfo])



    return (<Stack>
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>

        <Toggle id="differentBillingAddress" checked={props.userInvoceInfo.differentBillingAddress} onChange={firmaChanged} inlineLabel label="Chci použít Odlišnou fakturační adresu / Fakturace na firmu" />

            <TextField id="company" key="company" label="Firma" disabled={props.isLoading || !props.userInvoceInfo.differentBillingAddress } value={props.userInvoceInfo.company}
                onChange={setInfoChange} />

            <TextField id="ic" key="ic" label="IČ" disabled={props.isLoading || !props.userInvoceInfo.differentBillingAddress} value={props.userInvoceInfo.ic}
            onChange={setInfoChange} />
            <TextField id="dic" key="dic" label="DIČ" disabled={props.isLoading || !props.userInvoceInfo.differentBillingAddress} value={props.userInvoceInfo.dic}
            onChange={setInfoChange} />
            <TextField id="billingEmail" key="billingEmail" label="Email" required disabled={props.isLoading || !props.userInvoceInfo.differentBillingAddress} value={props.userInvoceInfo.billingEmail}
                onChange={setInfoChange} errorMessage={validation.billingEmail}/>

            <TextField required id="billingStreet" key="street" label="Ulice" disabled={props.isLoading || !props.userInvoceInfo.differentBillingAddress} value={props.userInvoceInfo.billingStreet}
                onChange={setInfoChange} errorMessage={validation.billingStreet}/>
            <TextField required id="billingCity" key="city" label="Město" disabled={props.isLoading || !props.userInvoceInfo.differentBillingAddress} value={props.userInvoceInfo.billingCity}
                onChange={setInfoChange} errorMessage={validation.billingCity} />
            <TextField required id="billingPostalCode" key="postalCode" label="PSČ" disabled={props.isLoading || !props.userInvoceInfo.differentBillingAddress} value={props.userInvoceInfo.billingPostalCode}
                onChange={setInfoChange} errorMessage={validation.billingPostalCode} />
        </Stack>
    </Stack>)
}